import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const PopupDescription = ({ children, image }) => (
  <div className={cx('component')}>
    {image && (
      <div className={cx('image')}>
        <img src={image} alt={children} />
      </div>
    )}

    <Text size="size5-r-s" tagType="p">{children}</Text>
  </div>
);

PopupDescription.propTypes = {
  children: PropTypes.string,
  image: PropTypes.string,
};
